module.exports = __webpack_public_path__ + "static/media/schedule_structure_change_lunch_time.50ceb39e.mov";